module.exports = __webpack_public_path__ + "static/media/IMG_8018.93272527.jpg";